<template>
  <div>
    <!-- 头部-->
    <NavTop style="width: 100%;"></Navtop>
    <div class="container">
      <div class="breadcrumb">
        <span @click="routerpush('/')">首页</span>
        <span style="cursor: pointer" @click="clickRenCai">人才培养</span>
        <span>{{ bigTitle }}</span>
      </div>
      <div class="tab-container">
        <div class="tab-header">
          <div class="tab-headerV" v-for="(item,index) in LeftData" :class="leftIdx == index?'activeLeft':''"
               :key="index"
               @click="nav(item,index)">
            <span>{{ item.name }}</span>
            <span></span>
          </div>
        </div>
        <div class="tab-body">
          <div class="shadow"></div>
          <div class="tab-bodyV">
            <div class="teacher-team panel">
              <!-- 标签 -->
              <div class="loc-nav">
                <!--                <ul class="loc-nav_ul" v-if="LeftData[leftIdx].children">-->
                <!--                  <li class="loc-nav_li" :class="tabsIdx == index?'activeV':''" v-for="(item,index) in LeftData[leftIdx].children"-->
                <!--                      :key="index" @click="clickTabs(index)">-->
                <!--                    <span>{{ item.name }}</span>-->
                <!--                  </li>-->
                <!--                </ul>-->
              </div>
              <!-- 内容 -->
              <ul class="teacher-team_ul" v-if="this.$route.params.tabBarId == 25">
                <li class="teacher-team_li" v-for="(item,index) in teachers" :key="index">
                  <img :src="item.coverUrl" alt>
                  <div class="teacher-team_li_right">
                    <h5>{{ item.title }}</h5>
                    <!--                    <em>职称/职务：讲师/摄影系主任</em>-->
                    <p v-html="item.introduce"></p>
                    <p v-html="item.content"></p>
                    <span @click="navPath(item)">详情</span>
                  </div>
                </li>
              </ul>
              <div style=" width: 100%;display: flex;justify-content: center;margin-bottom: 10px">
                <el-pagination v-if="total > pageSize" v-model="pageNum" @current-change="clickPage"
                               :page-size="pageSize"
                               background
                               layout="prev, pager, next"
                               :total="total"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import home from '../../api/home'

export default {
  data () {
    return {
      // 大标题
      bigTitle:'教师队伍',
      // 页数
      pageNum: 1,
      // 每页数量
      pageSize: 6,
      // 总条数
      total: 0,
      // 左边列表数据
      leftIdx: 0,
      LeftData: [],
      // 标签数据
      tabsIdx: 0,
      tabsData: [
        {txt: '师资概况'}
      ],
      // 内容
      teachers: []
    }
  },
  created () {
    this.getNav()
    this.getData(this.$route.params.tabBarId,this.pageNum,this.pageSize)
  },
  watch: {
    '$route' (to, from) {
      // 路由变化时执行的代码
      console.log(to.params.id)
      this.getNav()
      this.getData(this.$route.params.tabBarId,this.pageNum,this.pageSize)
    }
  },
  methods: {
    /**
     * 导航
     * */
    getTabBar(id){
      home.getTabBarOne({id})
        .then(res=>{
          console.log(res)
        })
        .catch(err=>{
          console.log(err)
        })
    },
    // 跳转
    navPath (item) {
      if (item.id) {
        this.$router.push({path: `/talent/detail/${item.id}`})
      }
    },
    // 获取内容
    async getData (tabBarId, pageNum, pageSize) {
      try {
        const res = await home.getWenZhang({tabBarId, pageNum, pageSize})
        this.teachers = res.rows
        this.total = res.total
      } catch (e) {
        console.log(e)
      }
    },
    // 跳转
    nav (item, index) {
      this.leftIdx = index
      this.bigTitle = item.name
      if (item.path.startsWith('https')) {
        window.open(item.path, '_blank')
        return
      }
      this.leftIdx = index
      if (item.appointTabId) {
        let encodedId = encodeURIComponent(item.appointTabId)
        let decodedId = decodeURIComponent(encodedId)
        this.$router.push(item.path + decodedId)
        // return
      }
    },
    // 点击分页
    clickPage (e) {
      this.pageNum = e
      this.getData(this.$route.params.tabBarId, this.pageNum, this.pageSize)
    },
    // 获取导航栏
    async getNav () {
      try {
        const res = await home.getNav({id: 5})
        this.LeftData = res.data.children
      } catch (e) {
        console.log(e)
      }
    },
    extractFirstAndSecondNumbers (str) {
      // 正则表达式匹配数字
      const regex = /\d+/g
      let match
      let numbers = []

      // 使用正则表达式的exec方法来循环匹配所有数字
      while ((match = regex.exec(str)) !== null) {
        numbers.push(match[0])
      }

      // 返回第一个和第二个数字，如果没有足够的数字则返回undefined
      return [numbers[0], numbers[1]]
    },
    // 点击标签变索引
    clickTabs (index) {
      this.tabsIdx = index
    },
    // 跳转
    routerpush (to) {
      this.$router.push(to)
    },
    // 点击人才培养
    clickRenCai () {
      this.$router.push({path: `/talents/5/25`})
    }
    // 上一页

    // 下一页
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;

  .breadcrumb {
    margin: 10px 0;
    display: flex;
    justify-content: end;

    span {
      display: flex;
      align-items: center;

      &:nth-child(1) {
        padding: 15px 15px 15px 0;
        font-size: 14px;
        color: #666;
        display: flex;
        justify-content: end;
        background: url(../../assets/images/read_arrow.png) no-repeat;
        background-position: right;
        background-size: 14px;
        margin-right: 2px;
      }

      &:nth-child(2) {
        padding: 15px 15px 15px 0;
        font-size: 14px;
        color: #666;
        display: flex;
        justify-content: end;
        background: url(../../assets/images/read_arrow.png) no-repeat;
        background-position: right;
        background-size: 14px;
        margin-right: 2px;
      }

      &:nth-child(3) {
        color: #9E070E;
        background-image: none;
        margin-right: 0;
        padding: 15px 0 15px 0;
        font-size: 14px;
        display: flex;
        justify-content: end;
        background-position: right;
        background-position-y: 16px;
        background-size: 14px;
      }
    }
  }

  .tab-container {
    margin: 10px 0;
    display: flex;
    flex-direction: row;
    border: 1px solid #C6C6C6;

    .tab-header {
      border-right: 1px solid #C6C6C6;
      width: 282px;

      .tab-headerV {
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        font-weight: 400;
        color: #666;
        border-left: 2px solid #9E070E;
        border-bottom: 1px solid #C6C6C6;
        padding: 15px 0 15px 41px;
        cursor: pointer;


        &:hover {
          color: #9E070E;
          background: white;
        }

        span {
          &:nth-child(1) {
            display: block;
            font-size: 16px;
          }

          &:nth-child(2) {
            width: 18px;
            height: 18px;
            margin-right: 25px;
            background: url(../../assets/images/read_arrow.png) no-repeat;
            display: block;
            font-size: 16px;
          }
        }
      }
    }

    .tab-body {
      width: 975px;

      .shadow {
        width: 975px;
        height: 14px;
        background: linear-gradient(180deg, #E6E6E6, #FFFFFF);
        margin-top: -1px;
      }

      .tab-bodyV {
        .teacher-team {
          width: 100%;
          padding: 0 12px;
          display: flex;
          flex-wrap: wrap;
          gap: 24px;
          // 标签
          .loc-nav {
            float: left;

            .loc-nav_ul {
              .loc-nav_li {
                float: left;
                font-size: 14px;

                &:hover {
                  border-bottom: 2px solid #E60012;
                  color: #E60012;
                }

                span {
                  padding: 0 20px;
                  height: 48px;
                  line-height: 48px;
                  display: inline-block;
                  cursor: pointer;
                }
              }
            }
          }

          // 内容
          .teacher-team_ul {
            //overflow: hidden;
            width: 975px;
            //height: 684px;

            .teacher-team_li {
              padding: 0;
              float: left;
              width: 48%;
              margin-bottom: 40px;
              transform: translateX(20px);

              img {
                width: 148px;
                height: 188px;
                object-fit: cover;
                float: left;
                background: #f2f2f2;
                border-radius: 6px;
                margin-right: 10px;
              }

              .teacher-team_li_right {
                width: 295px;
                height: 170px;
                float: right;

                h5 {
                  font-size: 16px;
                  font-weight: bold;
                  color: #333;
                  height: 25px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  line-height: 25px;
                  margin: 10px 0;
                }

                em {
                  color: #666;
                  display: inline-block;
                  height: 25px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  line-height: 25px;
                }

                p {
                  display: block;
                  color: #999;
                  height: 50px;
                  overflow: hidden;
                  line-height: 25px;
                }

                span {
                  display: block;
                  cursor: pointer;
                  width: 88px;
                  height: 30px;
                  background: #C9151E;
                  color: #fff;
                  text-align: center;
                  line-height: 30px;
                  margin-top: 15px;
                  border-radius: 30px;
                }
              }
            }
          }
        }
      }
    }
  }
}

* {
  list-style: none;
  margin: 0;
  padding: 0;
  text-decoration: none;
  outline: none;
}

.activeLeft {
  color: #9E070E !important;
  background: white !important;
}

.activeV {
  border-bottom: 2px solid #E60012;
  color: #E60012;
}

</style>
<style lang="less">
.el-pager {
  .number:hover {
    background-color: #8D080E !important;
    color: #fff !important;
  }
}

.active {
  background-color: #8D080E !important;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Talents/index.vue